import { Fragment, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { guardarTodosPendientes, quitarPendiente } from '../../../actions/inventarioCarga';

import ProductoCargaModal from './modals/ProductoCargaModal';
import VaciarPendientesModal from './modals/VaciarPendientesModal';

const CarritoPendientes = () => {
    const dispatch = useDispatch();

    const { pendingChanges } = useSelector((state) => state.inventarioCarga);

    const [showCarrito, setShowCarrito] = useState(false);
    const [showVaciar, setShowVaciar] = useState(false);
    const [statusGuardandoTodos, setStatusGuardandoTodos] = useState(false);

    const [tempIdEditar, setTempIdEditar] = useState(null);
    const [showEditar, setShowEditar] = useState(false);

    const allIds = pendingChanges?.allIds || [];
    const byId = pendingChanges?.byId || {};

    if (allIds.length === 0) {
        return null;
    }

    const onEditarPendiente = (tempId) => {
        setTempIdEditar(tempId);
        setShowEditar(true);
    };

    const onQuitarPendiente = (tempId) => {
        dispatch(quitarPendiente(tempId));
    };

    const onGuardarTodos = async () => {
        setStatusGuardandoTodos(true);
        const ok = await dispatch(guardarTodosPendientes());
        setStatusGuardandoTodos(false);

        if (ok) {
            setShowCarrito(false);
        }
    };

    const texto = allIds.length === 1 ? '1 pendiente' : `${allIds.length} pendientes`;

    return (
        <Fragment>
            <button
                type="button"
                className="btn btn-primary rounded-pill shadow"
                style={{ position: 'fixed', bottom: '24px', right: '24px', zIndex: 1040 }}
                onClick={() => setShowCarrito(true)}
            >
                <i className="fas fa-shopping-cart" /> {texto}
            </button>

            <Modal
                show={showCarrito}
                onHide={() => {
                    if (statusGuardandoTodos) return;
                    setShowCarrito(false);
                }}
                backdrop={statusGuardandoTodos ? 'static' : true}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Productos pendientes</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="table-responsive">
                        <table className="table table-sm table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>Producto</th>
                                    <th>Estado</th>
                                    <th className="text-end">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allIds.map((tempId) => {
                                    const pendiente = byId[tempId];

                                    return (
                                        <tr key={tempId}>
                                            <td>{pendiente?.nombre || 'Sin nombre'}</td>
                                            <td>
                                                {pendiente?.esNuevo ? (
                                                    <span className="badge bg-primary">Nuevo</span>
                                                ) : (
                                                    <span className="badge bg-warning text-dark">Editado</span>
                                                )}
                                            </td>
                                            <td className="text-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-link px-2"
                                                    title="Editar"
                                                    disabled={statusGuardandoTodos}
                                                    onClick={() => onEditarPendiente(tempId)}
                                                >
                                                    <i className="fa fa-edit text-warning" />
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-link px-2"
                                                    title="Quitar"
                                                    disabled={statusGuardandoTodos}
                                                    onClick={() => onQuitarPendiente(tempId)}
                                                >
                                                    <i className="fas fa-trash text-danger" />
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-outline-danger"
                        onClick={() => setShowVaciar(true)}
                        disabled={statusGuardandoTodos}
                    >
                        Vaciar lista
                    </button>

                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={onGuardarTodos}
                        disabled={statusGuardandoTodos}
                    >
                        {statusGuardandoTodos ? (
                            <Fragment>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" /> Guardando…
                            </Fragment>
                        ) : (
                            `Guardar todos (${allIds.length})`
                        )}
                    </button>
                </Modal.Footer>
            </Modal>

            <VaciarPendientesModal
                show={showVaciar}
                onHide={() => setShowVaciar(false)}
                onSuccess={() => {
                    setShowVaciar(false);
                    setShowCarrito(false);
                }}
            />

            <ProductoCargaModal
                show={showEditar}
                tempIdPendiente={tempIdEditar}
                onHide={() => {
                    setShowEditar(false);
                    setTempIdEditar(null);
                }}
            />
        </Fragment>
    );
};

export default CarritoPendientes;
